module.exports = __webpack_public_path__ + "ar.svg?4a30d4b2d64c05d601a16ec0fe44998b";